module.exports = __webpack_public_path__ + "static/media/magnetResults.1827f198.PNG";